module.exports = __webpack_public_path__ + "static/media/a-4-d.b92c01a9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/accessroies/a-4-d.jpg
// module id = 1103
// module chunks = 33